var $d49d621f310cf6ce$exports = {};
$d49d621f310cf6ce$exports = {
    "Empty": `\u{7A7A}`
};


export {$d49d621f310cf6ce$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
